if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        // Só desabilita o variantIdInput se ele existir (não existe em combos)
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // Verifica se é um combo
        const comboProducts = this.getComboProducts();
        const comboQuantity = this.getComboQuantity();

        console.log('DEBUG - Combo Variant IDs:', this.dataset.comboVariantIds);
        console.log('DEBUG - Combo Quantity:', this.dataset.comboQuantity);
        console.log('DEBUG - Combo Debug Info:', this.dataset.comboDebug);
        console.log('DEBUG - Parsed Products:', comboProducts);
        console.log('DEBUG - Parsed Quantity:', comboQuantity);

        // Se for combo válido, adiciona APENAS os produtos filhos
        if (comboProducts && comboProducts.length > 0 && comboQuantity > 0) {
          console.log('DEBUG - É COMBO! Adicionando produtos filhos:', comboProducts);
          this.addComboToCart(comboProducts, comboQuantity);
          return; // IMPORTANTE: retorna aqui para não executar a lógica normal
        }

        console.log('DEBUG - NÃO É COMBO! Adicionando produto normal');
        // Caso contrário, adiciona produto normal
        this.addNormalProductToCart();
      }

      getComboProducts() {
        try {
          const comboData = this.dataset.comboVariantIds;
          if (!comboData || comboData === '' || comboData === 'null') return null;
          
          const variantIds = comboData.split(',').map(id => id.trim()).filter(id => id !== '');
          if (variantIds.length === 0) return null;
          
          return variantIds;
        } catch (e) {
          console.error('Erro ao processar produtos do combo:', e);
          return null;
        }
      }

      getComboQuantity() {
        try {
          const qty = this.dataset.comboQuantity;
          if (!qty || qty === '' || qty === 'null') return 0;
          
          const parsed = parseInt(qty, 10);
          return isNaN(parsed) ? 0 : parsed;
        } catch (e) {
          console.error('Erro ao processar quantidade do combo:', e);
          return 0;
        }
      }

      async addComboToCart(comboProducts, comboQuantity) {
        try {
          const qtyPerProduct = Math.floor(comboQuantity / comboProducts.length);
          
          if (qtyPerProduct < 1) {
            this.handleErrorMessage('Quantidade insuficiente para dividir entre os produtos do combo.');
            this.resetSubmitButton();
            return;
          }

          // Prepara os itens do combo (comboProducts já são IDs de variantes)
          const items = comboProducts.map(variantId => {
            return {
              id: variantId,
              quantity: qtyPerProduct
            };
          });

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.headers['Content-Type'] = 'application/json';

          const body = { items };

          if (this.cart) {
            body.sections = this.cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = JSON.stringify(body);

          const response = await fetch(`${routes.cart_add_url}`, config);
          const responseData = await response.json();

          if (responseData.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: items.map(i => i.id).join(','),
              errors: responseData.errors || responseData.description,
              message: responseData.message,
            });
            this.handleErrorMessage(responseData.description);
            this.error = true;
            this.resetSubmitButton();
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: items.map(i => i.id).join(','),
              cartData: responseData,
            });
          }
          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(responseData);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(responseData);
          }
        } catch (e) {
          console.error('Erro ao adicionar combo ao carrinho:', e);
          this.handleErrorMessage('Erro ao adicionar combo ao carrinho.');
        } finally {
          this.resetSubmitButton();
        }
      }

      addNormalProductToCart() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.resetSubmitButton();
          });
      }

      resetSubmitButton() {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
